<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="报名"
        left-text="返回"
        left-arrow
        fixed
        @click-left="goBack()"
      />

      <div class="item-info">
        <h4>报名项目</h4>
        <div class="detail">
          <div class="tit">{{ pxitem.title }}</div>
          <div class="con ellipsis-2">{{ pxitem.content }}</div>
        </div>
      </div>
      
      <div class="form-info">
        <h4>报名信息</h4>
        <van-form @submit="onSubmit" @failed="onFailed" ref="form">
          <van-field
            v-model="form.name"
            name="name"
            label="姓名"
            placeholder="姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <van-field name="sex" label="性别"
            :rules="[{ required: true, message: '请选择性别' }]"
          >
            <template #input>
              <van-radio-group v-model="form.sex" direction="horizontal">
                <template v-for="item in sexList">
                  <van-radio :key="item.id" :name="item.id">{{ item.name }}</van-radio>
                </template>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="form.xh"
            name="xh"
            label="学号"
            placeholder="学号"
            :rules="[{ required: true, message: '请填写学号' }]"
          />
          <van-field
            v-model="form.sfzh"
            name="sfzh"
            label="身份证号"
            placeholder="身份证号"
            :rules="[{ required: true, pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, 
              message: '请填写正确的身份证号' }]"
          />
          <van-field
            type="number"
            v-model="form.mobile"
            name="mobile"
            label="手机号"
            placeholder="手机号"
            :rules="[{ required: true, pattern:/^1[3456789]\d{9}$/, message: '请填写正确的手机号' }]"
          />
          <van-field
            type="number"
            v-model="form.qq"
            name="qq"
            label="QQ"
            placeholder="QQ号"
            :rules="[{ required: false, pattern:'', type:'integer', message: '请填写QQ号' }]"
          />
          <van-field
            v-model="form.weixin"
            name="weixin"
            label="微信"
            placeholder="微信号"
            :rules="[{ required: false, message: '请填写微信号' }]"
          />
          <van-field
            readonly
            clickable
            name="picker"
            :value="form.xqname"
            label="校区"
            placeholder="点击选择校区"
            @click="showXq = true"
            :rules="[{ required: true, message: '请选择校区' }]"
          />
          <van-popup v-model="showXq" position="bottom">
            <van-picker
              show-toolbar
              :columns="xqList"
              value-key="name"
              @change="onChangeXq"
              @confirm="onConfirmXq"
              @cancel="showXq = false"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            name="picker"
            :value="form.xyname"
            label="学院"
            placeholder="点击选择学院"
            @click="showXy = true"
            :rules="[{ required: true, message: '请选择学院' }]"
          />
          <van-field
            v-model="form.bmzy"
            name="bmzy"
            label="拟报专业"
            placeholder="拟报研究生专业"
            :rules="[{ required: true, message: '请填写拟报研究生专业' }]"
          />
          <van-popup v-model="showXy" position="bottom">
            <van-picker
              show-toolbar
              :columns="xyList"
              value-key="name"
              @confirm="onConfirmXy"
              @cancel="showXy = false"
            />
          </van-popup>
          <van-field name="uploader" label="上传学生证或一卡通照片"
            :rules="[{ required: true, message: '请上传学生证或一卡通照片' }]"
          >
            <template #input>
              <van-uploader v-model="form.xszpic" :after-read="afterRead" :max-count="1" />
            </template>
          </van-field>
          <van-field v-if="pxitem.list" name="courseids" label="培训科目" class="course-field"
            :rules="[{ required: true, message: '请选择培训科目' }]"
          >
            <template #input>
              <van-checkbox-group v-model="form.courseids">
                <template v-for="item in pxitem.list">
                  <van-checkbox :key="item.id" :name="item.id" shape="square">
                    <div class="course-item">
                      <div class="name">{{ item.name }}</div>
                      <div class="prices">
                        <span v-if="item.market" class="market" v-html="webPrice(item.market)"></span>
                        <span class="price" v-html="webPrice(item.price)"></span>
                      </div>
                    </div>
                  </van-checkbox>
                </template>
              </van-checkbox-group>
            </template>
          </van-field>
          <div class="signup-btns">
            <div v-if="total" class="prices">
              小计：<span class="price" v-html="webPrice(total)"></span>
            </div>
            <van-button round block type="info" native-type="submit" :loading="saveLoading" :loading-text="saveTxt +'中...'">
              确定{{ saveTxt }}
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import siteMixin from '@/utils/site-mixin';
import { deepCopy } from '@/utils/utils';
export default {
  components: {
  },
  mixins: [siteMixin],
  props: {
    id: String,
    orderid: String
  },
  data() {
    return {
      error: false,
      isLoading: false,
      showXq: false,
      showXy: false,
      pxitem: {},
      form: {},
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters({
      sexList: [types.BASE_LOAD.sexList],
      xqList: [types.BASE_LOAD.xqList],
      xyList: [types.BASE_LOAD.xyList],
    }),
    saveTxt() {
      return this.orderid ? '更新' : '报名';
    },
    defaultData() {
      return {
        name: null,
        sex: null,
        sfzh: null,
        mobile: null,
        qq: null,
        weixin: null,
        xqid: null,
        xqname: null,
        xyid: null,
        xyname: null,
        xqzpic: null,
        bmzy: null,
        courseids: []
      }
    },
    total() {
      if (!this.pxitem.list) {
        return 0;
      }
      let list = this.pxitem.list.filter(d => {
        return this.form.courseids ? this.form.courseids.includes(d.id) : false;
      });
      return list.reduce((total, n) => {
        return total + n.price;
      }, 0);
    }
  },
  watch: {
    id() {
      this.loadData();
    },
    orderid() {
      this.loadData();
    }
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });

    this.loadData();
  },
  activated() {
    this.loadData();
  },
  mounted () {
    this.checkLogin();
  },
  methods: {
    loadData() {
      if (this.isLoading) {
        return;
      }
      this.pxitem = {};
      this.form = {};
      this.isLoading = true;

      if (this.orderid) {
        this.doGet({
          url: 'site/home/order/'+ this.orderid,
          data: {hascourse: true},
          okcb: (json) => {
            this.pxitem = Object.assign({}, { title: json.obj.title, content: json.obj.content, list: json.obj.list });
            this.form = Object.assign({}, this.defaultData, json.stu, { 
              itemid: json.obj.itemid,
              courseids: json.obj.courseids.split(','),
              xszpic: json.stu.xszpic ? [{
                  url: this.imgPath(json.stu.xszpic), status: 'done'
                }] : null
            });
          },
          cb: () => {
            this.$nextTick(() => this.isLoading = false);
          },
          errcb: () => {
            this.Toast('请求数据出错！');
          }
        });
      } else {
        this.doGet({
          url: 'site/home/item/'+ this.id,
          data: {hasstu: true},
          okcb: (json) => {
            this.pxitem = Object.assign({}, json);
            if (json.stu) {
              this.form = Object.assign({}, this.defaultData, json.stu, {
                id: null,
                xszpic: json.stu.xszpic ? [{
                    url: this.imgPath(json.stu.xszpic), status: 'done'
                  }] : null
              });
            }
            // 已报过订单，提示
            if (json.countOrder) {
              this.Dialog.confirm({
                title: '已报名提示',
                message: '你已有该项目的报名记录，确定仍要报名吗？',
              })
                .then(() => {
                  // on confirm
                })
                .catch(() => {
                  // on cancel
                  this.$router.push('/user');
                });
            }
          },
          cb: () => {
            this.$nextTick(() => this.isLoading = false);
          },
          errcb: () => {
            this.Toast('请求数据出错！');
          }
        });
      }

      if (!this.sexList || !this.sexList.length) {
        this.$store.dispatch(types.BASE_LOAD.sexList);
      }
      if (!this.xqList || !this.xqList.length) {
        this.$store.dispatch(types.BASE_LOAD.xqList);
      }
      if (!this.xyList || !this.xyList.length) {
        this.$store.dispatch(types.BASE_LOAD.xyList);
      }
    },
    onConfirmXq(data) {
      this.form.xqid = data.id;
      this.form.xqname = data.name;
      this.showXq = false;
    },
    onChangeXq(el, data) {
      this.onConfirmXq(data);
    },
    onConfirmXy(data) {
      this.form.xyid = data.id;
      this.form.xyname = data.name;
      this.showXy = false;
    },
    // 上传图片
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      this.doUpload4Vant({
        url: this.upload4Web,
        file: file.file,
        okcb: (json) => {
          file.status = 'done';
          file.url = json.pic;

          console.log(json, file)
          
        },
        errcb: (json) => {
          console.log(json)
          file.status = 'failed';
          file.message = json.message || '上传失败！';
        }
      });
    },
    onSubmit(values) {
      console.log('submit', values);
      console.log(this.form)
      let postData = deepCopy(this.form);
      // 规范数据
      if (!this.orderid) {
        postData.itemid = this.id;
      }
      postData.xszpic = postData.xszpic.length ? postData.xszpic[0].url : null;
      postData.courseids = postData.courseids.join(',');
      postData.amount = '' + this.total;
      postData.openid = this.member.openid;
      postData.paymethod = 'WX';
      postData._member = {id:this.member.id, mobile: this.form.mobile};
      postData.version === null ? postData.version = 1 : (postData.version += 1);

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });

      this.saveLoading = true;
      this.doPost({
        url: 'site/signup',
        data: postData,
        okcb: (json) => {
          // 如果已报名，则直接跳转到订单详情页
          if (json.isok) {
            this.skushow = false;
            this.$router.push('/order/'+ json.id);
            return;
          }
          // 如果需要公众号openid
          if (json.needopenid) {
            setTimeout(() => {
              this.login();
            }, 100);
            return;
          }

          let params = {goods: {name: this.pxitem.title, amount: this.total}, orderid:json.orderid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.$router.push({ name:'signup-pay', params: params });
        },
        cb: () => {
          this.saveLoading = false;
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
              if (json.obj && json.obj.orderid) {
                // 转订单页面
                this.$router.push('/order/'+ json.obj.orderid);
              }
            }, 10);
          }
        }
      });
    },
    onFailed({ errors }) {
      if (errors.length) {
        this.$refs.form.scrollToField(errors[0].name);
      }
      // console.log(errors)
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  /deep/ .van-field--error .van-field__control::placeholder {
    color: #ccc;
  }
}
.item-info {
  h4 {
    margin-bottom:.25rem;
    padding:0 .5rem;
    color:#888;
  }
  .detail {
    padding:.5rem .8rem;
    background-color:#fff;
  }
  .tit {
    .fontsize(1.2rem);
  }
  .con {
    margin-top:.25rem;
    color:#888;
  }
}
.form-info {
  padding-bottom:5.2rem;
  h4 {
    padding:0 .5rem;
    margin-bottom:.25rem;
    color:#888;
  }
  /deep/ .course-field {
    .van-checkbox-group,
    .van-checkbox__label {
      width:100%;
    }
  }
  /deep/ .course-item {
    .flex();
    padding:.35rem 0;
    .prices {
      margin-left: auto;
    }
    .market {
      display: inline-block;
      margin-right:.25rem;
      padding:0 .25rem;
      text-decoration: line-through;
      color:#aaa;
      small {
        .fontsize(.8rem);
      }
    }
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.4rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
.signup-btns {
  position:fixed;
  left:1rem;
  bottom: 1rem;
  right:1rem;
  .flex-center-v();
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
  .prices {
    margin-right:2rem;
    padding:.5rem 1rem;
    white-space: nowrap;
    flex-shrink: 0;
    background-color:#f0f0f0;
    border-radius:2rem;
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
</style>